module.exports = __webpack_public_path__ + "images/emoji/trophy.70f089120c9456263acc.png";